import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreviousRouterService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();


  constructor() {
  }
  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }
   clearUrl(){
     this.previousUrl.next(null);
   }
}
